import { CertificateStatusResponse } from './certificateStatus.types';
import {
	DeviceConfCodeRequestBody,
	DeviceConfCodeResponse,
} from './deviceConfig.types';

export type BuildStatus = {
	buildComplete: boolean;
	buildStatus:
		| 'FAILED'
		| 'FAULT'
		| 'IN_PROGRESS'
		| 'STOPPED'
		| 'SUCCEEDED'
		| 'TIMED_OUT';
	currentPhase: string;
	id: string;
	startTime: string;
};

export interface CertificateStatus {
	status: 'idle' | 'pending' | 'success' | 'error' | 'timeout';
	response: CertificateStatusResponse | null;
}
export interface ImplementationStoreState {
	msiInstaller: {
		status: 'idle' | 'pending' | 'success' | 'error' | 'timeout';
		downloadUrl: string;
		buildStatus: Partial<BuildStatus>;
		checkingBuildStatus: boolean;
	};
	configV2Zip: {
		initialized: boolean;
		blob?: Blob;
	};
	deployedGreengrassV2: {
		status: 'idle' | 'pending' | 'success' | 'error' | 'timeout';
	};
	configCode: {
		status: 'idle' | 'pending' | 'success' | 'error' | 'timeout';
		request: DeviceConfCodeRequestBody | null;
		response:
			| (Omit<DeviceConfCodeResponse, 'createdAt'> & {
					expiresAt: number;
			  })
			| null;
		firstTime: boolean;
	};
	certificateStatus: CertificateStatus;
}

export enum DeploymentOptions {
	LATEST = 'LATEST',
	DOWNGRADE_ALL = 'DOWNGRADE_ALL',
	DOWNGRADE_AWS_ONLY = 'DOWNGRADE_AWS_ONLY',
}

export type PartialImplementationStoreState = Partial<ImplementationStoreState>;
